"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const axios_1 = __importDefault(require("axios"));
const Utils_1 = require("@becrop/components/Map/Utils");
class SummaryFieldsService {
    constructor() {
    }
    async sendFields(fields) {
        var _a, _b;
        const formData = [];
        let response;
        fields.forEach((field) => {
            var _a, _b, _c, _d;
            const f = {
                geodata: field.geodata.trim().toUpperCase().startsWith('POLYGON')
                    ? (0, Utils_1.polygonToMultiPolygonWKT)(field.geodata)
                    : field.geodata,
                fieldName: field.fieldName,
                farmName: field.farmName,
                acreage: {
                    unit: field.sizeUnit,
                    value: field.size
                },
                crop: {
                    cropId: (_a = field.crop) === null || _a === void 0 ? void 0 : _a.id,
                    cropName: (_b = field.crop) === null || _b === void 0 ? void 0 : _b.name
                },
                managementPractice: {
                    mpId: (_c = field.managementPractice) === null || _c === void 0 ? void 0 : _c.id,
                    name: (_d = field.managementPractice) === null || _d === void 0 ? void 0 : _d.name
                },
                provider: {
                    fieldId: field.providerFieldId,
                    type: field.provider
                }
            };
            formData.push(f);
        });
        try {
            response = await axios_1.default.post('/gisfields/process', formData);
        }
        catch (error) {
            response = { type: 'error', messages: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.messages) || 'An error ocurred' };
            return response;
        }
        return response.data;
    }
}
exports.default = SummaryFieldsService;
